export default __webpack_public_path__ + "static/media/image-water.d5de3eb5.png";